import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex, Box, Label, Checkbox, Text } from 'pcln-design-system'
import { ANALYTICS_CATEGORY } from '../../constants/Constants'
import { send } from '../../utils/PCLN-Analytics'
import CheckboxProductCopy from './CheckboxProductCopy'

// Fix for devices of width <= 360px where the text overflows on next line
const StyledBox = styled(Box)`
  @media (max-width: 360px) {
    padding-right: 0px;
  }
`

const ProductTypeCheckbox = props => (
  <Flex alignItems='center'>
    <Text fontSize={0} color='text.light' pr={[1, 2, null, 3]}>
      <CheckboxProductCopy> {props.text ? props.text : 'Need anything else?'}</CheckboxProductCopy>
    </Text>
    <Flex>
      {props.productsOptions.map(option => {
        const isSelected = props.selectedProducts.some(
          product => product === option.type
        )

        return (
          <StyledBox key={option.name} mt={1} pr={[1, 2, 3, 4]}>
            <Label fontSize={0} htmlFor={option.id}>
              <Checkbox
                aria-checked={isSelected}
                aria-label={option.label}
                checked={isSelected}
                id={option.id}
                name={option.name}
                onChange={e => {
                  if (e.target.checked) {
                    send({
                      action: 'Add Product Checkbox',
                      category: props.gaCategory,
                      data: `${props.gaLabelPrefix}${option.gaLabel}`
                    })
                  }
                  props.onChange(e)
                }}
                value={option.type}
              />
              {` ${option.label} `}
            </Label>
          </StyledBox>
        )
      })}
    </Flex>
  </Flex>
)

ProductTypeCheckbox.defaultProps = {
  gaCategory: ANALYTICS_CATEGORY,
  gaLabelPrefix: '',
  productsOptions: [
    {
      name: 'Hotel',
      type: 'STAY',
      label: 'Add a hotel',
      id: 'add-a-hotel-checkbox',
      gaLabel: 'add hotel'
    },
    {
      name: 'Car',
      type: 'DRIVE',
      label: 'Add a car',
      id: 'add-a-car-checkbox',
      gaLabel: 'add car'
    }
  ],
  selectedProducts: ['FLY']
}

ProductTypeCheckbox.propTypes = {
  gaCategory: PropTypes.string,
  gaLabelPrefix: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  productsOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      label: PropTypes.string,
      id: PropTypes.string
    })
  ),
  selectedProducts: PropTypes.arrayOf(PropTypes.string),
  text: PropTypes.string
}

export default ProductTypeCheckbox
